<template>
    <form>

        <div class="row">
            <div class="large-6 columns">
                <label for="diameter">Diameter of tank (metres):</label>
            </div>
            <div class="large-6 columns">
                <input
                    type="number"
                    name="diameter"
                    id="diameter"
                    class="tac"
                    v-model="diameter"
                    @keyup.enter="calculate"
                >
            </div>
        </div>

        <div class="row">
            <div class="large-6 columns">
                <label for="length">Length / height of tank (metres):</label>
            </div>
            <div class="large-6 columns">
                <input
                    type="number"
                    name="length"
                    id="length"
                    class="tac"
                    v-model="length"
                    @keyup.enter="calculate"
                >
            </div>
        </div>

        <div class="summary">

            <div class="row">
                <div class="large-6 columns">
                    <label for="capacity">Capacity (cubic metres):</label>
                </div>
                <div class="large-6 columns">
                    <input
                        type="text"
                        name="capacity"
                        id="capacity"
                        class="tac"
                        disabled
                        v-model="capacity"
                    >
                </div>
            </div>

            <div class="row">
                <div class="large-6 columns">
                    <label for="fertiliser">BFS 30-0-0-6 liquid fertiliser (tonnes):</label>
                </div>
                <div class="large-6 columns">
                    <input
                        type="text"
                        name="fertiliser"
                        id="fertiliser"
                        class="tac"
                        disabled
                        v-model="fertiliser"
                    >
                </div>
            </div>

        </div>

        <div class="row">
            <div class="column">
                <button type="button" class="button" @click.prevent="calculate">CALCULATE</button>
                <button type="button" class="alert button" @click.prevent="reset">RESET</button>
            </div>
        </div>

    </form>
</template>
<script>
    export default {
        data() {
            return {
                diameter: '',
                length: '',
                capacity: '',
                fertiliser: ''
            }
        },
        methods: {
            calculate() {
                if (this.diameter === '' || this.length === '') {
                    return;
                }
                this.capacity = window.Math.round(( ( this.diameter / 2 ) * ( this.diameter / 2 ) * 3.142 ) * this.length);
                this.fertiliser = window.Math.round(this.capacity * 1.308);
            },
            reset() {
                this.diameter = '';
                this.length = '';
                this.capacity = '';
                this.fertiliser = '';
            }
        }
    }
</script>